import { carouselData } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            专题盘点
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            聚焦热门网红人物的深度专题与系列盘点，一次性吃透每个大瓜
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {carouselData.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200/60 transition-all cursor-pointer"
            >
              <div className="relative w-full aspect-[2/1] overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-full text-xs font-medium bg-accent-100 text-accent-700">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-medium text-foreground-900 text-base md:text-lg mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.summary}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}